import "../style/Footer.css";

export const Footer = () => {
  return (
    <div className="footer">
      <p>© 2023 Eszter Kövesdi </p>
    </div>
  );
};
